import { useEffect, useRef, useState } from 'react';
import TextInput from '../../../../components/textInput';
import TextSelect from '../../../../components/textSelect';
import DateInput from '../../../../components/dateInput';
import ChangePasswordDialog from './changePasswordDialog';
import request from '../../../../lib/request';

const GENDER = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
};

const Profile = ({
  newUserInfo,
  infoChanged,
  handleNewUserInfo,
  handleSubmit,
  preference,
}) => {
  const changePasswordRef = useRef(null);

  const [countryList, setCountryList] = useState([]);

  useEffect(() => {
    getCountryList();
  }, []);

  const getCountryList = async () => {
    try {
      const { result } = await request.get('/signup/static-country');

      if (result) {
        setCountryList([{ flag: '', name: 'Unknown' }, ...result]);
      }
    } catch (err) {
      console.log(err?.message);
    }
  };

  const openChangePasswordDialog = () => {
    if (changePasswordRef.current) {
      changePasswordRef.current.showModal();
    }
  };

  const closeChangePasswordDialog = () => {
    if (changePasswordRef.current) {
      changePasswordRef.current.close();
    }
  };

  return (
    <div>
      <div className='grid grid-cols-2 gap-2 text-sm'>
        <TextInput
          label='Firstname'
          value={newUserInfo.firstname}
          onChange={handleNewUserInfo('firstname')}
        />
        <TextInput
          label='Lastname'
          value={newUserInfo.lastname}
          onChange={handleNewUserInfo('lastname')}
        />
        <TextInput
          label='Nickname'
          value={newUserInfo.nickname}
          onChange={handleNewUserInfo('nickname')}
        />
        <TextSelect
          label='Gender'
          value={newUserInfo.gender}
          options={[
            { key: GENDER.MALE, value: 'Male' },
            { key: GENDER.FEMALE, value: 'Female' },
            { key: GENDER.NOT_SPECIFIED, value: 'Not Specified' },
          ]}
          onChange={handleNewUserInfo('gender')}
        />
        <TextInput
          label='Height (cm)'
          value={newUserInfo.height}
          onChange={handleNewUserInfo('height')}
        />
        <TextInput
          label={`Weight (${preference.weightUnit?.toLowerCase()})`}
          value={newUserInfo.weight}
          onChange={handleNewUserInfo('weight')}
        />
        <DateInput
          label='Birth'
          value={newUserInfo.birth}
          onChange={handleNewUserInfo('birth')}
          inputProps={{
            style: {
              WebkitAppearance: 'none',
              MozAppearance: 'none',
            },
          }}
        />
        <TextSelect
          label='Country'
          value={newUserInfo.country}
          options={countryList.map(({ flag, name }) => ({
            key: name,
            value: `${name} ${flag}`,
          }))}
          onChange={handleNewUserInfo('country')}
        />
      </div>
      <div className='flex justify-between gap-2 pb-12 text-sm mt-4'>
        <div className='flex-1'>
          <button
            className='w-full border rounded-xl px-3 py-2'
            onClick={openChangePasswordDialog}
          >
            Change Password
          </button>
        </div>
        <div className='flex-1'>
          <button
            className={`w-full border rounded-xl px-3 py-2 ${
              !infoChanged && 'opacity-30'
            }`}
            disabled={!infoChanged}
            onClick={handleSubmit}
          >
            Update
          </button>
        </div>
      </div>
      <ChangePasswordDialog
        dialogRef={changePasswordRef}
        closeDialog={closeChangePasswordDialog}
      />
    </div>
  );
};

export default Profile;
